/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/function-component-definition */
import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PaperManageTableSearchParams } from '../model/paperManage';
import { useUser } from './UserContext';

interface PaperManageContext {
	searchParams: PaperManageTableSearchParams;
	setSearchParams: React.Dispatch<React.SetStateAction<PaperManageTableSearchParams>>;
}

const PaperManageContext = createContext<PaperManageContext | undefined>(undefined);

export const PaperManageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const { isAdmin, isLawyer, isViewer } = useUser();
	const { state } = useLocation();

	// if (!(isAdmin || isLawyer || isViewer)) {
	// 	return <Navigate to='/' replace />;
	// }

	const [searchParams, setSearchParams] = useState<PaperManageTableSearchParams>({
		currentPage: 0,
		searchType: 'title',
		searchText: '',
		rowsPerPage: 10,
		// orderColumn: -1,
		// order: 'desc',
	});

	const { searchType, searchText, rowsPerPage } = searchParams;

	useEffect(() => {
		setSearchParams(prev => ({ ...prev, currentPage: 0 }));
	}, [searchType, searchText, rowsPerPage, state]);

	return (
		<PaperManageContext.Provider value={{ searchParams, setSearchParams }}>{children}</PaperManageContext.Provider>
	);
};

export function usePaperManageList() {
	const context = useContext(PaperManageContext);
	if (context === undefined) {
		throw new Error('PaperManage must be used within a PaperManageProvider');
	}

	return context;
}
